import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, unref as _unref, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "w-full text-left text-sm"
}
const _hoisted_2 = { class: "border-b border-gray-200 text-gray-500" }
const _hoisted_3 = {
  key: 0,
  class: "py-2 pr-4 font-medium"
}
const _hoisted_4 = { class: "py-3 pr-4 font-medium" }
const _hoisted_5 = ["href"]
const _hoisted_6 = { class: "py-3 pr-4 text-gray-700" }
const _hoisted_7 = ["href"]
const _hoisted_8 = { class: "py-3 pr-4 text-gray-700" }
const _hoisted_9 = { class: "py-3 pr-4 text-gray-700" }
const _hoisted_10 = {
  key: 0,
  class: "py-3 pr-4"
}
const _hoisted_11 = { class: "py-3" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = {
  key: 2,
  class: "mt-4 flex items-center justify-between"
}
const _hoisted_14 = { class: "text-sm text-gray-500" }

import { ArrowDownTrayIcon } from '@heroicons/vue/24/outline'
import { computed } from 'vue'

import EmptyState from '@/components/neue/EmptyState.vue'
import NeueButton from '@/components/neue/NeueButton.vue'
import { mapRelationship } from '@/store/mappers'

// One page of a reseller's orders: `orders` is { rows, page, total, pageSize }.
// With show-status, a paid order reads "Paid" only when the merchant marked it
// as paid; anything settled through checkout (card or 100% code) is "Order Placed".

export default {
  __name: 'ResellerOrdersTable',
  props: {
  orders: { type: Object, required: true },
  showStatus: { type: Boolean, default: false },
  emptyDescription: { type: String, default: '' }
},
  emits: ['download', 'change-page'],
  setup(__props, { emit: __emit }) {

const props = __props
const emit = __emit

const pageCount = computed(() => Math.max(1, Math.ceil(props.orders.total / props.orders.pageSize)))

const changePage = page => {
  if (page < 0 || page > pageCount.value - 1) return
  emit('change-page', page)
}

const payment = bottle => mapRelationship(bottle.relationships?.bottle_payment?.data)

const markedAsPaid = bottle => payment(bottle)?.attributes?.reason === 'mark_as_paid'

// Placed orders are dated by their payment; unplaced carts have none.
const orderDate = bottle => payment(bottle)?.attributes?.created_at ?? bottle.attributes.created_at

const formatDate = iso => (iso ? new Date(iso).toLocaleDateString(undefined, { month: 'short', day: 'numeric' }) : '')

const customerName = bottle =>
  mapRelationship(bottle.relationships?.conversation_user_pair?.data)?.attributes?.display_name ?? ''

const cartTotal = bottle =>
  mapRelationship(bottle.relationships?.checkout?.data)?.attributes?.cart_total_amount?.format ?? ''

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (!__props.orders.rows.length)
      ? (_openBlock(), _createBlock(EmptyState, {
          key: 0,
          plural: "orders",
          description: __props.emptyDescription
        }, null, 8, ["description"]))
      : (_openBlock(), _createElementBlock("table", _hoisted_1, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", _hoisted_2, [
              _cache[2] || (_cache[2] = _createElementVNode("th", { class: "py-2 pr-4 font-medium" }, "Order", -1)),
              _cache[3] || (_cache[3] = _createElementVNode("th", { class: "py-2 pr-4 font-medium" }, "Customer", -1)),
              _cache[4] || (_cache[4] = _createElementVNode("th", { class: "py-2 pr-4 font-medium" }, "Date", -1)),
              _cache[5] || (_cache[5] = _createElementVNode("th", { class: "py-2 pr-4 font-medium" }, "Cart Total", -1)),
              (__props.showStatus)
                ? (_openBlock(), _createElementBlock("th", _hoisted_3, "Status"))
                : _createCommentVNode("", true),
              _cache[6] || (_cache[6] = _createElementVNode("th", { class: "py-2 font-medium" }, [
                _createElementVNode("span", { class: "sr-only" }, "Download report")
              ], -1))
            ])
          ]),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.orders.rows, (bottle) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: bottle.id,
                class: "border-b border-gray-100"
              }, [
                _createElementVNode("td", _hoisted_4, [
                  _createElementVNode("a", {
                    href: `/order/${bottle.id}`,
                    target: "_blank",
                    rel: "noopener",
                    class: "text-blue-600 hover:text-blue-900 hover:underline"
                  }, " #" + _toDisplayString(bottle.attributes.display_id || bottle.id), 9, _hoisted_5)
                ]),
                _createElementVNode("td", _hoisted_6, [
                  (bottle.relationships?.conversation_user_pair?.data?.id)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        href: `/profile/${bottle.relationships.conversation_user_pair.data.id}`,
                        target: "_blank",
                        rel: "noopener",
                        class: "text-blue-600 hover:text-blue-900 hover:underline"
                      }, _toDisplayString(customerName(bottle)), 9, _hoisted_7))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(_toDisplayString(customerName(bottle)), 1)
                      ], 64))
                ]),
                _createElementVNode("td", _hoisted_8, _toDisplayString(formatDate(orderDate(bottle))), 1),
                _createElementVNode("td", _hoisted_9, _toDisplayString(cartTotal(bottle)), 1),
                (__props.showStatus)
                  ? (_openBlock(), _createElementBlock("td", _hoisted_10, [
                      _createElementVNode("span", {
                        class: _normalizeClass([markedAsPaid(bottle) ? 'bg-green-100 text-green-800' : 'bg-blue-100 text-blue-800', "px-2 py-0.5 rounded-full text-xs font-medium"])
                      }, _toDisplayString(markedAsPaid(bottle) ? 'Paid' : 'Order Placed'), 3)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("td", _hoisted_11, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "text-gray-400 hover:text-gray-700",
                    title: "Download a report for this order",
                    onClick: $event => (emit('download', bottle))
                  }, [
                    _createVNode(_unref(ArrowDownTrayIcon), {
                      class: "h-4 w-4",
                      "aria-hidden": "true"
                    })
                  ], 8, _hoisted_12)
                ])
              ]))
            }), 128))
          ])
        ])),
    (pageCount.value > 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
          _createVNode(NeueButton, {
            type: "secondary",
            size: "sm",
            disabled: __props.orders.page === 0,
            onClick: _cache[0] || (_cache[0] = $event => (changePage(__props.orders.page - 1)))
          }, {
            default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
              _createTextVNode(" Previous ", -1)
            ]))]),
            _: 1
          }, 8, ["disabled"]),
          _createElementVNode("span", _hoisted_14, "Page " + _toDisplayString(__props.orders.page + 1) + " of " + _toDisplayString(pageCount.value), 1),
          _createVNode(NeueButton, {
            type: "secondary",
            size: "sm",
            disabled: __props.orders.page >= pageCount.value - 1,
            onClick: _cache[1] || (_cache[1] = $event => (changePage(__props.orders.page + 1)))
          }, {
            default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
              _createTextVNode(" Next ", -1)
            ]))]),
            _: 1
          }, 8, ["disabled"])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

}